import { render } from "./PersonalDataScreen.vue?vue&type=template&id=13b6f00a&scoped=true&lang=html"
import script from "./PersonalDataScreen.vue?vue&type=script&lang=js"
export * from "./PersonalDataScreen.vue?vue&type=script&lang=js"

import "./PersonalDataScreen.vue?vue&type=style&index=0&id=13b6f00a&lang=css&scoped=true"

import exportComponent from "/Users/peterdevos/Sites/bcfcareer25/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13b6f00a"]])

export default __exports__